module.exports = __webpack_public_path__ + "assets/img/box1-8.605d39c1.svg";